import styled from 'styled-components';
export const Wrapper = styled.div `
  .form__content {
    .p {
      margin-top: 0.5rem;
    }
  }
`;
export default {
    Wrapper,
};
